export default function (eventData = {}) {
  const targetPage = eventData.targetPage
  if (!targetPage) {
    console.error('当前页面不存在！', targetPage)
    return
  }
  window.router.push({ name: targetPage, query: window.router.currentRoute.query })
}
